import { render } from "./standing.svg?vue&type=template&id=01ad05c7"
const script = {}
script.render = render

export default script